import Vue from 'vue';
import VueRouter from 'vue-router';
import LoginService from '../services/login_service.js';
/*
import Home from '../views/home/Home.vue';
import Login from '../views/login/Login.vue';
import Noticia from '../views/noticia/admin_noticia.vue';
import Noticias from '../views/noticias/admin_noticias.vue';
import Categories from '../views/categories/admin_categories.vue';
import Category from '../views/category/admin_category.vue';
import SubCategories from '../views/subcategories/admin_subcategories.vue';
import SubCategory from '../views/subcategory/admin_subcategory.vue';
import Brands from '../views/brands/admin_brands.vue';
import Brand from '../views/brand/admin_brand.vue';
import Product from '../views/product/admin_product.vue';
import products from '../views/products/admin_products.vue'; 
import Banner from '../views/banner/admin_banner.vue';
import Banners from '../views/banners/admin_banners.vue'; 
import Customer from '../views/customer/admin_customer.vue';
import customers from '../views/customers/admin_customers.vue'; 
import CustomerShipping from '../views/customers_shipping/admin_customers_shipping.vue';
import customers_shippings from '../views/customers_shippings/admin_customers_shippings.vue'; 
import Sale from '../views/sale/admin_sale.vue';
import Sales from '../views/sales/admin_sales.vue'; 
import SaleProduct from '../views/sale_products/admin_sale_products.vue';
import SaleProducts from '../views/sale_products/admin_sale_products.vue'; */

const Home = () => import('../views/home/Home.vue');
const Login = () => import('../views/login/Login.vue');
const Paciente = () => import('../views/paciente/admin_paciente.vue'); 
const Pacientes = () => import('../views/pacientes/admin_pacientes.vue');
const Internacion = () => import('../views/internacion/admin_internacion.vue'); 
const Internaciones = () => import('../views/internaciones/admin_internaciones.vue');
const Cirugias = () => import('../views/cirugias/admin_cirugias.vue');
const Cirugia = () => import('../views/cirugia/admin_cirugia.vue');
const Postoperatorio  = () => import('../views/postoperatorio/admin_postoperatorio.vue');
const Postoperatorios  = () => import('../views/postoperatorios/admin_postoperatorios.vue'); 
const Intraoperatorio  = () => import('../views/intraoperatorio/admin_intraoperatorio.vue');
const AltaInternacion  = () => import('../views/alta_internacion/admin_alta_internacion.vue'); 
const PaseSala  = () => import('../views/pase_sala/admin_pase_sala.vue'); 
const Estadisticas  = () => import('../views/estadisticas/admin_estadisticas.vue'); 
const EstCirugia  = () => import('../views/est_cirugia/admin_est_cirugia.vue'); 	
const EstCama = () => import('../views/est_cama/admin_est_cama.vue');
const EstServicio = () => import('../views/est_servicio/admin_est_servicio.vue'); 	
const Facturacion = () => import('../views/facturacion/admin_facturacion.vue'); 	
const Facturar = () => import('../views/facturacion/admin_facturar.vue'); 	
const Usuarios = () => import('../views/usuarios/admin_usuarios.vue'); 	
const Usuario = () => import('../views/usuario/admin_usuario.vue'); 	


Vue.use(VueRouter)

const routes = [
	{ path: '/', name: 'Home',component: Home, meta: {title: 'Base cirujanos'} },
	{ path: '/login', name: 'Login', component: Login },  
	{ path: '/paciente', name: 'Paciente', component: Paciente },
	{ path: '/paciente/:id', name: 'PacienteM', component: Paciente },
	{ path: '/ver-paciente/:id', name: 'PacienteV', component: Paciente },
	{ path: '/pacientes', name: 'pacientes', component: Pacientes },
	{ path: '/internacion', name: 'Internacion', component: Internacion },
	{ path: '/internacion/:id', name: 'InternacionM', component: Internacion },
	{ path: '/ver-internacion/:id', name: 'InternacionV', component: Internacion },
	{ path: '/internaciones', name: 'Internaciones', component: Internaciones },
	{ path: '/cirugia', name: 'Cirugia', component: Cirugia },
	{ path: '/cirugia/:id', name: 'CirugiaM', component: Cirugia },
	{ path: '/ver-cirugia/:id', name: 'CirugiV', component: Cirugia },
	{ path: '/cirugias', name: 'Cirugias', component: Cirugias },
	{ path: '/postoperatorio/:id', name: 'PostoperatorioM', component: Postoperatorio },
	{ path: '/postoperatorios', name: 'Postoperatorios', component: Postoperatorios },
	{ path: '/intraoperatorio/:id', name: 'IntraoperatorioM', component: Intraoperatorio },
	{ path: '/altainternacion/:id', name: 'AltaInternacion', component: AltaInternacion },
	{ path: '/pase-sala', name: 'PaseSala', component: PaseSala },
	{ path: '/estadisticas', name: 'Estadisticas', component: Estadisticas },
	{ path: '/est-cirugia', name: 'EstCirugia', component: EstCirugia },
	{ path: '/est-cama', name: 'EstCama', component: EstCama },
	{ path: '/est-servicio', name: 'EstServicio', component: EstServicio },
	{ path: '/facturacion', name: 'Facturacion', component: Facturacion },
	{ path: '/facturar/:id', name: 'Facturar', component: Facturar },
	{ path: '/usuarios', name: 'Usuarios', component: Usuarios },
	{ path: '/usuario/:id', name: 'UsuarioM', component: Usuario },
	{ path: '/usuario', name: 'Usuario', component: Usuario },
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const loginService = new LoginService();
	let menuItemActive = document.querySelector('.router-link-active');
	if(menuItemActive) {
		menuItemActive.className = menuItemActive.className.replace("router-link-active", "")
	} else {
		console.log("chau")
	}
	if (to.name == 'Login') {
		document.body.className = 'login';
	}
	if (from.name == 'Login') {
		document.body.className = '';
	}
	if (to.name !== 'Login' && !loginService.getEstaLogueado()) {
		loginService.chkLogin({}).then(function(response) {
				if(response.body && response.body.status && response.body.status == 'success') {
					next();
				} else {
					next({ name: 'Login' });
				}
			}, function(error) { 
				next({ name: 'Login' });
				return error;
			});
	}
	else { 
		next();
	}
	//next()
})

export default router
